export default function PHP_clearstatcache() {
  return (
    <div>
      <h1>PHP_clearstatcache</h1>
    </div>
  );
}
